/** FileUpload hands back one File, a list, or null depending on `multiple`. */
export function asFiles(files: File | File[] | null): File[] {
  if (!files) return []
  return Array.isArray(files) ? files : [files]
}

export function attachmentLabel(files: File[]): string {
  if (files.length === 0) return 'No files chosen'
  if (files.length === 1) return files[0].name
  return `${files.length} files`
}
